import { useCallback, useEffect, useRef, useState } from "react";
function useRunCallbackNextRender() {
    const [increment, setIncrement] = useState({});
    const ref = useRef([]);
    useEffect(()=>{
        let c;
        while(c = ref.current.pop()){
            c();
        }
    }, [
        increment
    ]);
    return useCallback((callback)=>{
        ref.current.push(callback);
        setIncrement({});
    }, []);
}
export { useRunCallbackNextRender };
